import { render, staticRenderFns } from "./ModalBox.vue?vue&type=template&id=46ee5d66&"
import script from "./ModalBox.vue?vue&type=script&lang=js&"
export * from "./ModalBox.vue?vue&type=script&lang=js&"
import style0 from "./ModalBox.vue?vue&type=style&index=0&id=46ee5d66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports